import { gql } from 'apollo-boost';

export const minusPhraseLibraryRowFragment = gql`
    fragment minusPhraseLibraryRowFragment on GdGetMinusKeywordsPacksItem {
        id
        linkedAdGroupsCount
        minusKeywords
        name
    }
`;

export const minusPhraseLibraryConstantsFragment = gql`
    fragment minusPhraseLibraryConstantsFragment on GdDirectConstantsMinusWordsLibValidationData {
        libMinusKeywordsTextMaxLength
        maxLibraryPacksCount
        maxLinkedPacksToOneAdGroup
        maxNameLength
        maxWordsInMinusPhrase
        nameAllowLetters
        textAllowLetters
    }
`;

export const minusPhraseLibraryQuery = gql`
    query minusPhraseLibraryQuery($input: GdGetMinusKeywordsPacksInput!) {
        reqId: getReqId
        getLibraryMinusKeywordsPacks(input: $input) {
            cacheKey
            rowset {
                ...minusPhraseLibraryRowFragment
            }
            totalCount
        }
    }
    ${minusPhraseLibraryRowFragment}
`;

export const minusPhraseLibraryGridQuery = gql`
    query minusPhraseLibraryGridQuery(
        $minusPhraseInput: GdGetMinusKeywordsPacksInput!
        $login: String!
        $campaignInput: GdCampaignsContainerInput!
    ) {
        reqId: getReqId
        getLibraryMinusKeywordsPacks(input: $minusPhraseInput) {
            cacheKey
            rowset {
                ...minusPhraseLibraryRowFragment
            }
            totalCount
        }
        client(searchBy: { login: $login }) {
            campaigns(input: $campaignInput) {
                rowset {
                    id
                }
            }
        }
    }
    ${minusPhraseLibraryRowFragment}
`;
